import React from "react";
import { Gift, Clock, AlertTriangle, CheckCircle2, XCircle } from "lucide-react";

const STATUS = {
  trialing: { label: "Teste grátis", icon: Gift, cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  active: { label: "Ativo", icon: CheckCircle2, cls: "bg-primary/10 text-primary border-primary/30" },
  payment_due: { label: "Pagamento pendente", icon: AlertTriangle, cls: "bg-amber-500/10 text-amber-700 border-amber-500/40" },
  expired: { label: "Expirado", icon: XCircle, cls: "bg-muted text-muted-foreground border-border" },
  canceled: { label: "Cancelado", icon: XCircle, cls: "bg-muted text-muted-foreground border-border" },
};
const fmt = (iso) => { try { return new Date(iso).toLocaleDateString("pt-BR"); } catch { return ""; } };

export default function SubscriptionStatusCard({ sub, onPay, onCancel, busy }) {
  if (!sub || sub.status === "none") return null;
  const st = STATUS[sub.status] || STATUS.active;
  const Icon = st.icon;
  return (
    <div data-testid="subscription-status-card" className={`rounded-3xl border p-5 flex flex-col sm:flex-row sm:items-center gap-4 ${st.cls}`}>
      <div className="w-11 h-11 rounded-2xl bg-white/70 flex items-center justify-center shrink-0"><Icon className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <p className="font-heading font-bold text-base text-foreground">
          Plano {sub.plan_name} · <span data-testid="subscription-status-label">{st.label}</span>
        </p>
        <p className="text-sm mt-0.5 flex items-center gap-1" data-testid="subscription-status-detail">
          <Clock className="w-3.5 h-3.5" />
          {sub.status === "trialing" && <>Restam <b>{sub.trial_days_left} dias</b> grátis · termina em {fmt(sub.trial_ends_at)}. Sem cobrança até lá.</>}
          {sub.status === "active" && sub.plan_expires_at && <>Renovação em {fmt(sub.plan_expires_at)}</>}
          {sub.status === "payment_due" && <>Seu teste terminou. Pague até {fmt(sub.grace_ends_at)} ({sub.grace_days_left} dia(s)) para manter o plano.</>}
          {["expired", "canceled"].includes(sub.status) && <>Seus dados foram mantidos. Assine para reativar.</>}
        </p>
      </div>
      <div className="flex gap-2 shrink-0">
        {sub.status === "payment_due" && (
          <button data-testid="subscription-pay-now" disabled={busy} onClick={onPay} className="rounded-full bg-amber-500 text-white px-5 py-2.5 text-sm font-semibold disabled:opacity-60">Pagar agora</button>
        )}
        {["trialing", "active", "payment_due"].includes(sub.status) && (
          <button data-testid="subscription-cancel" disabled={busy} onClick={onCancel} className="rounded-full border border-border bg-white/60 px-4 py-2.5 text-sm font-semibold text-foreground disabled:opacity-60">Cancelar plano</button>
        )}
      </div>
    </div>
  );
}
